<template>
    <img class="msp-logo-app" :src="logoSrc" :alt="altText" />
</template>

<script>
import logoDefault from "../../../grafica/logo/logo-esteso-colore-negativo.svg"
import env from "@mixins/environment.js"
import { mapGetters } from 'vuex'

const component = {
    name: "MspLogoApp",
    mixins: [
        env,
    ],
    computed: {
        ...mapGetters('utente', [
            'utente',
        ]),
        logoSrc() {
            const url = this.utente?.logo_url;
            return url ? `${this.api_base_url}/public/loghi_allenatori/${url}` : logoDefault;
        },
        altText() {
            return this.utente?.logo_url ? (this.utente?.nome_brand ?? "") : "CoachPeaking";
        },
    },
};

export default component;
</script>
